// Load configuration data (items config, positions config) - MUST be first
// This populates GlobalState with data needed by all other modules
import './config/init'

import '../styles/index.scss'
import audioManager from './audio/audioManager'
import buttons from './ui/buttons'
import { getApp } from './canvas/scene/sceneManager'
import createScene from './canvas/scene'
import { preloadAssets } from './data/assetLoader'

init()

function init(): void {
  // Handles all audio playback
  audioManager.init()

  // Manages UI button interactions
  buttons.init()

  setCanvasVisible(true)

  if (getApp()) {
    return
  } else {
    // Load all assets before creating the scene
    preloadAssets(() => {
      audioManager.startAudio()
      createScene()
    })
  }
}

function setCanvasVisible(visible: boolean) {
  document.querySelector('.canvas-container')?.classList.toggle('hidden', !visible)
}
